import React from 'react';
import LeftBanner from './LeftBanner';

const Banner = () => {
  return (
    <section
      id="home"
      className="w-full pt-10 pb-20 flex flex-col gap-10 xl:gap-0 items-center border-b-[1px] font-titleFont border-b-gray-800 bg-bodyColor relative overflow-hidden"
    >
      {/* Sci-Fi Grid Background */}
      <div className="absolute inset-0 w-full h-full bg-grid-pattern opacity-30 z-0"></div>

      {/* Deep Space Gradient Overlay */}
      <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-bodyColor via-transparent to-bodyColor z-0 pointer-events-none"></div>
      <div className="absolute top-0 w-full h-[500px] bg-gradient-to-b from-[#00f3ff]/5 to-transparent blur-3xl rounded-full z-0 pointer-events-none"></div>

      <div className="relative w-full flex flex-col z-10 px-4">
        <LeftBanner />
      </div>
    </section>
  );
};

export default Banner;
